import styled from 'styled-components'

export const NavBar = styled.div`
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 65px;
    border-bottom: 1px solid #e5e9f2;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--white);
    z-index: 5;

    button.MuiButtonBase-root.MuiButton-root.MuiButton-text.btnMenuMobile {
        background: #fff;
        padding: 0;
        min-width: 0;
        width: 42px;
        height: 42px;
        border-radius: 100%;
        margin: 0 10px 0 0;
    }

    @media (min-width: 994px) {
        button.MuiButtonBase-root.MuiButton-root.MuiButton-text.btnMenuMobile {
            display: none;
        }
    }

    @media (max-width: 993px) {
        button.MuiButtonBase-root.MuiButton-root.MuiButton-text.btnMenuMobile {
            display: flex;
        }
    }
`

NavBar.Content = styled.div`
    max-width: 1880px;
    width: 100%;
    height: 66px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    @media (width <= 1366px) {
        padding: 0 20px;
        max-width: 1220px !important;        
    }
`

NavBar.Logo = styled.div`
    max-width: 275px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`

NavBar.ImgLogo = styled.img`
    width: 100%;
    height: auto;
`

NavBar.Actions = styled.div`
    height: 66px;
    display: flex;
    align-items: center;
    justify-content: center;
`

NavBar.LeftContent = styled.div`
    display: flex;
    flex-direction: row;
`

NavBar.Full = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    @media (max-width: 993px) {
        display: none !important;
    }
`

NavBar.Left = styled.div`
    max-width: 260px;
    width: 100%;
`

NavBar.Center = styled.div`
    width: calc(100% - 600px);
`

NavBar.Right = styled.div`
    max-width: 330px;
    width: 100%;

    #UserData_Name {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        max-width: 140px;
    }
`

NavBar.Mobile = styled.div`
    width: 100%;

    @media (min-width: 992px) {
        display: none !important;
    }
`

NavBar.MobileBox = styled.div`
    -webkit-box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);
	box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);
	width: 100%;
	border-radius: 100px;
`

NavBar.MobileContent = styled.div`
    display: flex;
	align-items: center;
	justify-content: center;

    button#btn-popover-filter-search-bar {
        position: relative !important;
        top: 0 !important;
    }

    button#btn-inside-popover-filter-search-bar {
        min-width: 42px;
        max-width: 42px;
        height: 42px;
    }
`

NavBar.MobileLeft = styled.div`
    display: flex;
	align-items: center;
	justify-content: center;
	max-width: 42px;
	min-width: 42px;
	border-radius: 100%;
    margin-left: 5px;

    button#btn-inside-popover-filter-search-bar {
        position: relative;
        right: 0;
    }

    .App {
        max-width: 42px;
        min-width: 42px;
        border-radius: 100%;
    }

    button#btn-inside-popover-filter-search-bar svg {
        color: var(--primary);
    }

    button#btn-inside-popover-filter-search-bar svg.MuiSvgIcon-root {
        color: var(--primary);
    }

    button.MuiButtonBase-root.MuiButton-root.MuiButton-text.btnMenuMobile {
        color: var(--primary);
    }
`

NavBar.MobileCenter = styled.div`
    width: 100%;

    input#Search_Input {
        width: calc(100% - 24px);
    }
`

NavBar.MobileRight = styled.div`
    display: flex;
	align-items: center;
	justify-content: center;
    margin-right: 5px;

    button#btn-userdata div#UserData_Icon {
        background: transparent;
        color: var(--primary);
    }

    div#UserData_UserData {
        background: transparent !important;
        max-width: 42px;
        min-width: 42px;
        height: 42px;
        border-radius: 100%;
    }

    div#UserData_UserData button#btn-userdata {
        background: var(--primary);
        min-width: 42px;
        max-width: 42px;
        height: 42px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 !important;
    }

    /* div#UserData_UserData {
        background: #3a5e96 !important;
        border-radius: 100%;
    } */

    div#UserData_UserData button#btn-userdata {
        background: transparent;
        border-radius: 100%;
    }

    div#UserData_UserData button#btn-userdata div#UserData_Name {
        display: none;
    }

    div#UserData_UserData div#UserData_CaretIcon {
        display: none;
    }
`

export const Search = styled.div`

`

Search.Box = styled.div`
    position: relative;
	gap: 0;
	-webkit-box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);
	box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);
	display: flex;
	align-items: center;
	justify-content: flex-start;
	border-radius: 100px;
	padding: 7px;
	max-width: 610px;
	width: 100%;

    button.MuiButtonBase-root.MuiButton-root.MuiButton-text.btn-search {
        background: linear-gradient(189deg, rgb(23, 126, 201) 0%, rgb(38, 71, 184) 100%);
        color: var(--white);
        min-width: 36px;
        padding: 0;
        width: 36px;
        height: 36px;
        border-radius: 100%;
        z-index: 99;
    }

    button.MuiButtonBase-root.MuiButton-root.MuiButton-text.btn-search-filters {
        color: var(--black);
        min-width: 36px;
        padding: 0;
        width: 36px;
        height: 36px;
        border-radius: 100%;
    }
`

Search.Input = styled.input`
	height: 28px;
	padding: 2px 0px;
	border: 0;
	outline: none;
	text-decoration: none;
    padding-left: 10px;
	z-index: 99;
	background: transparent;
	width: calc(100% - 82px);
`

NavBar.FilterBox = styled.div`
    background: var(--white);
    position: fixed;
    top: 66px;
    left: 0;
    width: 100%;
    height: calc(100% - 66px);
    overflow: auto;
    z-index: 500;
`

NavBar.FilterContent = styled.div`
    padding: 20px;
`